import { createModel } from '@rematch/core';

import type { RootModel } from 'store/models';

export type StateType = {
  isProfileReady: boolean;
  readyProfileId: number | null;
};

type SetProfileReadyPayload = {
  isReady: boolean;
  profileId?: number | null;
};

const initialState: StateType = {
  isProfileReady: false,
  readyProfileId: null,
};

export const app = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setProfileReady: (state: StateType, payload: SetProfileReadyPayload) => ({
      ...state,
      isProfileReady: payload.isReady,
      readyProfileId: payload.isReady ? payload.profileId ?? null : null,
    }),
    resetProfileReady: (state: StateType) => ({
      ...state,
      isProfileReady: false,
      readyProfileId: null,
    }),
  },
});
